import cn from '@/app/[locale]/(website)/components/utils/cn'

export default function ChevronToRight({className}: {className?: string}) {
    return (
        <svg
            viewBox="0 0 20 20"
            className={cn(
                'fill-current opacity-75 transition-transform duration-200 transform rotate-0',
                className,
            )}
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
            role="img"
            focusable="false"
        >
            <path d="M12.95 10.707l.707-.707L8 4.343 6.586 5.757 10.828 10l-4.242 4.243L8 15.657l4.95-4.95z" />
        </svg>
    )
}
